import { useEffect, useState, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router";
import axios from 'axios';

import { AppContext } from '../../context.js';
import { FilePlus, Search, Plus, CheckCircle, Phone, Bell } from "../../files/icons/index.js";

import { Status } from '../components/component.js';
import Loading from '../components/loading.js';
import Helmet from "../components/helmet.js";

import { DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

function Referrals(props) {
  const { notificationObject } = props;

  const context = useContext(AppContext);

  const navigate = useNavigate();

  // Search params
  const [searchParams] = useSearchParams();
  const templateID = searchParams.get('templateID');
  const importID = searchParams.get('importID');

  const [loading, setLoading] = useState(true);

  // Search
  const step = 10;
  const [prompt, setPrompt] = useState(null);
  const [filter, setFilter] = useState({
    // role: ["patient"],
    templateID: templateID ? [templateID] : null,
    importID: importID ? [importID] : null,
    statusType: ["TO_DO"],
    //archived: false,
  });
  const [limit, setLimit] = useState(step);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);

  // Data
  const [referrals, setReferrals] = useState([]);
  const [settings, setSettings] = useState(null);

  // Initial data load
  // Default limit and offset used
  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/referrals', {
        prompt: prompt,
        filter: filter,
        limit: limit,
        offset: offset,
      }),
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((referrals, settings) => {
      setFilter(referrals.data.filter);
      setReferrals(referrals.data.referrals);
      setCount(referrals.data.count);

      setSettings(settings.data);

      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  // Load more patients
  // Limit and offset moved forward by step
  function extendLimit() {
    let u = context.addSpiner();
    axios.post('/api/admin/referrals', {
      prompt: prompt,
      filter: filter,
      limit: limit+step,
      offset: limit,
    }).then((response) => {
      setFilter(response.data.filter);
      setReferrals((prevReferrals) => {
        const newReferrals = response.data.referrals.filter(
          (newReferral) => !prevReferrals.some((prevReferral) => prevReferral.id === newReferral.id)
        );
        return [...prevReferrals, ...newReferrals];
      });
      setLimit(response.data.limit);
      setOffset(response.data.offset);
      setCount(response.data.count);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  // Prompt search fired
  // Limit and offset reset to default
  function search() {
    let u = context.addSpiner();
    axios.post('/api/admin/referrals', {
      prompt: prompt,
      //filter: {role: ["patient"], archived: false},
      limit: step,
      offset: 0,
    }).then((response) => {
      setFilter(response.data.filter);
      setReferrals(response.data.referrals);
      setLimit(response.data.limit);
      setOffset(response.data.offset);
      setCount(response.data.count);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  function renderFilters() {
    return (
      <div className="d-flex justify-content-start align-items-center ps-4 ">
        <div className="item typo-normal-150 text-muted"><Plus width={16} height={16} color={'grey'} /> Website Call</div>
      </div>
    );
  }

  // Render helpers
  function renderReferrals() {
    var filteredReferrals = referrals;
    // if (searchText !== "") {
    //   filteredProfiles = filteredProfiles.filter((profile) => {
    //     return profile.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
    //     profile.lastName.toLowerCase().includes(searchText.toLowerCase());
    //   });
    // }

    if (filteredReferrals.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No referrals found</div>
        </div>
      );
    }

    return filteredReferrals.map((referral) => {
      return (
        <div onClick={() => navigate(`/referral/${referral.id}`)} className="card clickable mb-2">
          <div className="card-content sm">
            <div className="row">
              <div className="col-xs-3">
                <div className="typo-strong-175">{referral.firstName + " " + referral.lastName}</div>
                <div className="typo-normal-150">{referral.selfReferral ? "Self Referral" : referral.partnerName}</div>
              </div>
              <div className="col-xs-3">
                <div className="typo-normal-150">{referral.message}</div>
              </div>
              <div className="col-xs-3 col-xs-offset-1">
                {/* {renderAction('phone', 'Call tomorrow to discuss opportunity')}
                {renderAction('bell', 'Tomorrow is the visit date')}
                {renderAction('check-circle', 'Send follow-up email after visit')} */}
              </div>
              <div className="col-xs-2 text-end">
                {referral.statusType === "TO_DO" && (
                  <Status color={'grey'} muted={true} text={'To Do'} />
                )}
                {referral.statusType === "COMPLETED" && (
                  <Status color={'green'} muted={true} text={'Completed'} />
                )}
                {referral.statusType === "CANCELED" && (
                  <Status color={'red'} muted={true} text={'Archived'} />
                )}
                <div className="typo-normal-125 mt-2">{DateToFormat(DatetimeToDate(referral.createdAt), context.dateFormat)} {DateToFormat(DatetimeToDate(referral.createdAt), context.timeFormat === "us" ? "AMPM" : "HH:mm")}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderAction(icon, title) {
    let i;
    switch (icon) {
      case 'phone':
        i = <Phone width={16} height={16} color={'grey'} />;
        break;
      case 'bell':
        i = <Bell width={16} height={16} color={'grey'} />;
        break;
      case 'check-circle':
        i = <CheckCircle width={16} height={16} color={'grey'} />;
        break;
      default:
        i = null;
    }
    return (
      <div className="d-flex justify-content-start align-items-center typo-normal-150 mb-1">{i} <span className="ms-2">{title}</span></div>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet title="Patients" />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center">
                <span className="typo-hero-small">Referrals</span>
                {/* <span className="typo-normal-175 mt-2 ms-3">Here is an overview of your demographic information</span> */}
              </div>
              <div className="w-25 text-end">
                <div className="item typo-normal-150 ms-2" onClick={() => navigate('/referral/create')}><FilePlus width={16} height={16} color={'grey'} /> Create Referral</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            
            <div className="card shadowmore mb-4">
              <div className="card-content sm">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-start align-items-center w-100">
                    <Search width={16} height={16} color={'grey'} />
                    <input type="text" className="input borderless w-100 ms-2" placeholder="Type and press enter to search..." value={prompt || ''} onChange={(e) => setPrompt(e.target.value)} onKeyUp={(e) => e.key === 'Enter' && search()} autoFocus={true} />
                  </div>
                  <div style={{minHeight: 28}}>
                  </div>
                </div>
              </div>
            </div>

            {/* {renderFilters()} */}

            {renderReferrals()}

            {(count !== 0 && limit < count) && (
              <div className="d-flex justify-content-center align-items-center">
                <div className="item typo-normal-150" onClick={() => extendLimit()}>show more</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Referrals;
